import axios from "axios";
import { b2cSalespersonDailyCallStatsApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${getUserToken()}`,
    },
});

/**
 * @param {Record<string, string | number | undefined>} [params] e.g. sales_person, date, date__gte, ordering, page
 */
export const getB2cSalespersonDailyCallStatsList = async (params) => {
    const qs = params ? new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)) : "";
    const url = qs ? `${b2cSalespersonDailyCallStatsApi}?${qs}` : b2cSalespersonDailyCallStatsApi;
    return axios.get(url, authHeaders());
};

export const getB2cSalespersonDailyCallStatsDetail = async (id) =>
    axios.get(`${b2cSalespersonDailyCallStatsApi}${id}/`, authHeaders());

export const createB2cSalespersonDailyCallStats = async (data) =>
    axios.post(b2cSalespersonDailyCallStatsApi, data, authHeaders());

export const patchB2cSalespersonDailyCallStats = async (id, data) =>
    axios.patch(`${b2cSalespersonDailyCallStatsApi}${id}/`, data, authHeaders());

export const deleteB2cSalespersonDailyCallStats = async (id) =>
    axios.delete(`${b2cSalespersonDailyCallStatsApi}${id}/`, authHeaders());
